import cn from 'clsx'
import s from './FeatureBar.module.css'
import Link from 'next/link'
import Button from '@components/ui/Button/Button'
import { useContext } from 'react'
import { CookieContext } from 'context/cookieContext'

interface FeatureBarProps {
  className?: string
  title: string
  description?: string
  hide?: boolean
  action?: React.ReactNode
}

const FeatureBar: React.FC<FeatureBarProps> = ({ title, className }) => {
  const { acceptedCookies, onAcceptCookies } = useContext(CookieContext)

  const rootClassName = cn(
    s.root,
    {
      transform: true,
      'translate-y-0 opacity-100': !acceptedCookies,
      'translate-y-full opacity-0': acceptedCookies,
    },
    className
  )
  return (
    <div className={rootClassName}>
      <span className="block md:inline-block">
        {title}
        <Link href="/info/privacy-policy">
          <a aria-label="Learn more about our privacy and cookie policy">
            Learn More
            <span className="sr-only">about our privacy and cookie policy</span> {/* Text for SEO and screen readers */}
          </a>
        </Link>
      </span>
      <Button
        variant="type2"
        className={s.button}
        onClick={() => onAcceptCookies()}
      >
        GOT IT!
      </Button>
    </div>
  )
}

export default FeatureBar
